import React from 'react'
import { Parser } from 'html-to-react';
import userCategoryName from "../../../../constants/userCategory";
const XPERTOS = "10873693";

const InvoiceAddress = (invoiceData) => {
    return (
        <>
            <div className="invo-from-to">
                <div className="invo-from-sing">
                    <div className="from-sing-head">From</div>
                    <div className="name-sing-head">{invoiceData.invoiceData ? invoiceData.invoiceData.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(invoiceData.invoiceData.user_category) ? (invoiceData.invoiceData.company_name) : (`${String(invoiceData.invoiceData.first_name) === "null" ? "" : invoiceData.invoiceData.first_name} ${String(invoiceData.invoiceData.middle_name) === "null" ? "" : invoiceData.invoiceData.middle_name} ${String(invoiceData.invoiceData.last_name) === "null" ? "" : invoiceData.invoiceData.last_name}`) : (
                      <div
                        style={{
                          width: "150px",
                          height: "17px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    )}</div>
                    <div className="addres-sing-head styll2">{invoiceData.invoiceData ? (invoiceData.invoiceData.address) : (
                      <div
                        style={{
                          width: "200px",
                          height: "14px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    )}</div>
                    <div className="tele-sing-head styll2"> {invoiceData.invoiceData ? (`Tel: ${invoiceData.invoiceData.mobile_no}`) : (
                      <div
                        style={{
                          width: "120px",
                          height: "14px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    )}</div>
                    <div className="mail-sing-head styll2"> {invoiceData.invoiceData ? (`Email: ${invoiceData.invoiceData.email}`) : (
                      <div
                        style={{
                          width: "180px",
                          height: "14px",
                          backgroundColor: "#e5e7eb",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    )}</div>
                </div>
                <div className="invo-to-sing">
                    <div className="to-sing-head">To</div>
                    
                    <div className="toname-sing-head">
                        {invoiceData.invoiceData ? (
                            `${String(invoiceData.invoiceCompanyDetails?.legal_entity_company_name) === "null" ? "" : invoiceData.invoiceCompanyDetails?.legal_entity_company_name}` || `${String(invoiceData.invoiceCompanyDetails?.wx_company) === "null" ? "" : invoiceData.invoiceCompanyDetails?.wx_company}`
                        ) : (
                            <div
                              style={{
                                width: "150px",
                                height: "17px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                        )}
                    </div>
                    <div className="toaddres-sing-head styll2">
                        {invoiceData?.invoiceData ? (
                            <pre style={{ fontFamily: 'halyard-display' }}>
                                {Parser().parse(invoiceData.invoiceCompanyDetails?.address)}
                            </pre>
                        ) : (
                            <div
                              style={{
                                width: "200px",
                                height: "14px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                        )}
                    </div>
                    <div className="totele-sing-head styll2">
                        {invoiceData.invoiceData ? (
                            `Tel: ${invoiceData.invoiceCompanyDetails?.mobile_no}`
                        ) : (
                            <div
                              style={{
                                width: "120px",
                                height: "14px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                        )}
                    </div>
                    <div className="tomail-sing-head styll2">
                        {invoiceData.invoiceData ? (
                            `Email: ${invoiceData.invoiceCompanyDetails?.email}`
                        ) : (
                            <div
                              style={{
                                width: "180px",
                                height: "14px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                              }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <style>{`
                @keyframes pulse {
                  0%, 100% {
                    opacity: 1;
                  }
                  50% {
                    opacity: 0.5;
                  }
                }
              `}</style>
        </>
    )
}

export default InvoiceAddress